import * as React from "react";
function ChevronLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.636 22a.337.337 0 01-.24-.104l-9.152-9.273a.868.868 0 01-.06-.07c-.267-.344-.24-.872.06-1.176l9.15-9.273A.34.34 0 0116.637 2c.104 0 .204.052.273.14a.46.46 0 01-.031.588L7.726 12l9.151 9.27c.15.153.165.418.031.59a.344.344 0 01-.272.14z"
  }));
}
const ForwardRef = React.forwardRef(ChevronLeftIcon);
export default ForwardRef;